export default "__VITE_ASSET__aa507647__"